import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";
import { CSSProperties } from "react";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      cursor: "pointer",
      userSelect: "none",
      backgroundColor: theme.card.background,
      borderRadius: constants.radius.button,
      display: "flex",
      justifyContent: "center",
      margin: "0 auto 40px",
      width: 325,
      padding: spacing.s,
    },
    text: {
      color: theme.text.error,
    },
  };

  return styles;
};
